import React, { useEffect, useState } from 'react';
import HandoverItemsModel from './models/HandoverItemsModel';

function ViewHandoverItems(props) {
    const [handoverItemsData, setHandoverItemsData] = useState(new HandoverItemsModel());

    useEffect(() => {
        setHandoverItemsData(props.HandoverItemsData);
    }, [props.HandoverItemsData]);

    return (
        <>
            <div className="row">
                <div className="mb-3 add-product">
                    <label className="form-label">Handover Item Type</label>
                    <input type="text" className="form-control" value={handoverItemsData.HandoverItemType} disabled />
                </div>
                <div className="mb-3 add-product">
                    <label className="form-label">Handover Item Title</label>
                    <input type="text" className="form-control" value={handoverItemsData.HandoverItemTitle} disabled />
                </div>
                <div className="mb-3 add-product">
                    <label className="form-label">Description</label>
                    <textarea className="form-control h-100" rows="5" value={handoverItemsData.Description} disabled />
                </div>
            </div>
        </>
    );
}

export default ViewHandoverItems;
